/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    array,
    bool,
    func,
    number, object,
    string,
} from 'prop-types';

import ProductUI from './ProductUI';
import noop from '../../../../../helpers/noop';

const DesktopUIContainerV2 = ({
    products, minRowsToShow, personalizedCarousel, handleClickCallback, recentlyViewedSectionBGColor, dynamicPriceInstance, productSkuPrices, dynamicPriceIsLoading, dataTestId,
}) => {
    const [rowCount, setRowCount] = useState(minRowsToShow);
    const [isExpanded, setIsExpanded] = useState(false);

    const PRODUCT_TO_SHOW_PER_ROW = 3;
    const totalProductsRows = Math.ceil(products?.length > 0 ? ((products?.length) / PRODUCT_TO_SHOW_PER_ROW) : 1);
    const maxRowsAllowed = Math.min(totalProductsRows, 4);

    const handleSeeMore = () => {
        const newRowCount = rowCount + 1;
        if (newRowCount >= maxRowsAllowed) {
            setIsExpanded(true);
        }
        setRowCount(newRowCount);
    };

    const handleSeeLess = () => {
        setIsExpanded(false);
        setRowCount(minRowsToShow);
    };

    const maxProductsToShow = Math.min(rowCount, maxRowsAllowed) * PRODUCT_TO_SHOW_PER_ROW;
    const centerAligned = personalizedCarousel?.product_alignment === 'center';

    const {
        getRetailPrice, getSalePrice,
    } = dynamicPriceInstance;

    return (
        <ProductUI
            slicedProducts={products?.slice(0, maxProductsToShow)}
            maxRowsAllowed={maxRowsAllowed}
            minRowsToShow={minRowsToShow}
            handleSeeLess={handleSeeLess}
            handleSeeMore={handleSeeMore}
            handleLinkOnClick={(partNumber) => handleClickCallback(partNumber, false)}
            isExpanded={isExpanded}
            showFullGrid={PRODUCT_TO_SHOW_PER_ROW === 6}
            containerBGColor={recentlyViewedSectionBGColor}
            productSkuPrices={productSkuPrices}
            getRetailPrice={getRetailPrice}
            getSalePrice={getSalePrice}
            dynamicPriceIsLoading={dynamicPriceIsLoading}
            centerAligned={centerAligned}
            dataTestId={dataTestId}
        />

    );
};

DesktopUIContainerV2.propTypes = {
    products: array.isRequired,
    minRowsToShow: number,
    handleClickCallback: func,
    personalizedCarousel: object,
    recentlyViewedSectionBGColor: string,
    dynamicPriceInstance: func,
    productSkuPrices: array,
    dynamicPriceIsLoading: bool,
    dataTestId: string,
};

DesktopUIContainerV2.defaultProps = {
    minRowsToShow: 1,
    handleClickCallback: noop,
    personalizedCarousel: {},
    recentlyViewedSectionBGColor: '',
    dynamicPriceInstance: noop,
    productSkuPrices: [],
    dynamicPriceIsLoading: false,
    dataTestId: '',
};

export default DesktopUIContainerV2;
